import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmptyLayoutComponent } from './empty.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        EmptyLayoutComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
    ],
    exports: [
        EmptyLayoutComponent
    ]
})
export class EmptyLayoutModule {
}
